import { FormGroup } from 'arag-ui-lib';
import CONTENT_STRINGS from '../../../helpers/contentStrings';
import { FORM_GROUP_VARIANTS } from '../../../helpers/formGroupVariants';
import { DATE_FORMAT, INITIAL_OPTIONS } from '../../../helpers/constants';

const StagedStep3 = (props) => {
    const {
        stagedPremiumsWizard,
        changeStagedPremiumFormData,
        isApplicationPremium,
    } = props;
    const coverageTypeOptions = [...INITIAL_OPTIONS, ...stagedPremiumsWizard.coveragesOptions.map(c => {
        return {key: c.id, label: c.name};
    })];
    const deductiblesOptions = [...INITIAL_OPTIONS, ...stagedPremiumsWizard.deductiblesOptions.map(c => {
        return {key: c.id, label: c.name};
    })];
    const endorsementOptions = [...INITIAL_OPTIONS, ...stagedPremiumsWizard.endorsementsOptions.map(c => {
        return {key: c.id, label: c.name};
    })];

    return (
        <div>
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-5'}
                label={CONTENT_STRINGS.NOTES}
                variant={FORM_GROUP_VARIANTS.TEXT_AREA}
                inputProps={{
                    id: 'notes',
                    name: 'notes',
                    onChange: evt => {changeStagedPremiumFormData(evt.target.name,evt.target.value,);},
                    rows: 4,
                    value: stagedPremiumsWizard.notes,
                }}
                formGroupTestId={'edit-staged-application-premium-setting-notes-and-coverage-notes'}
            />
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-5'}
                label={CONTENT_STRINGS.COMMENTS}
                variant={FORM_GROUP_VARIANTS.TEXT_AREA}
                inputProps={{
                    id: 'comments',
                    name: 'comments',
                    rows: 4,
                    onChange: evt => {changeStagedPremiumFormData(evt.target.name, evt.target.value,);},
                    value: stagedPremiumsWizard.comments,
                }}
                formGroupTestId={'edit-staged-application-premium-setting-notes-and-coverage-comments'}
            />
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-5'}
                label={CONTENT_STRINGS.COVERAGE_TYPES}
                variant={FORM_GROUP_VARIANTS.SELECT}
                inputProps={{
                    id: 'coverageType',
                    name: 'selectedCoverageType',
                    onChange: evt => { changeStagedPremiumFormData( evt.target.name, parseInt(evt.target.value),);},
                    options: coverageTypeOptions,
                    value: stagedPremiumsWizard.selectedCoverageType,
                    required: true,
                }}
                formGroupTestId={'edit-staged-application-premium-setting-notes-and-coverage-coverage-type'}
            />
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-5'}
                label={CONTENT_STRINGS.DEDUCTIBLES}
                variant={FORM_GROUP_VARIANTS.SELECT}
                inputProps={{
                    id: 'deductibles',
                    name: 'selectedDeductible',
                    onChange: evt => { changeStagedPremiumFormData( evt.target.name, parseInt(evt.target.value)) },
                    options: deductiblesOptions,
                    value: stagedPremiumsWizard.selectedDeductible,
                    required: true,
                }}
                formGroupTestId={'edit-staged-application-premium-setting-notes-and-coverage-deductible'}
            />
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-5'}
                label={CONTENT_STRINGS.ENDORSEMENTS}
                variant={FORM_GROUP_VARIANTS.SELECT}
                inputProps={{
                    id: 'endorsements',
                    name: 'selectedEndorsement',
                    onChange: evt => { changeStagedPremiumFormData( evt.target.name, parseInt(evt.target.value)) },
                    options: endorsementOptions,
                    value: stagedPremiumsWizard.selectedEndorsement,
                    required: true,
                }}
                formGroupTestId={'edit-staged-application-premium-setting-notes-and-coverage-endorsements'}
            />
            {
                isApplicationPremium == false
                ?
                    <FormGroup
                        labelSize={'col-sm-3'}
                        inputSize={'col-sm-5'}
                        label={CONTENT_STRINGS.VALID_FROM}
                        variant={FORM_GROUP_VARIANTS.DATE}
                        inputProps={{
                            id: 'validFrom',
                            name: 'validFrom',
                            required: true,
                            dateInputProps: {
                                minDate: new Date(),
                                onChange: evt => {changeStagedPremiumFormData('validFrom', evt);},
                                autoComplete: 'off',
                                dateFormat: DATE_FORMAT,
                                selected: stagedPremiumsWizard.validFrom,
                                placeholderText: CONTENT_STRINGS.DATE_PLACEHOLDER,
                                required: true,
                            },
                        }}
                        formGroupTestId={'staged-premium-setting-valid-from'}
                    />
                :
                    null
            }
            {
                isApplicationPremium == false
                ?
                    <FormGroup
                        labelSize={'col-sm-3'}
                        inputSize={'col-sm-5'}
                        label={CONTENT_STRINGS.VALID_UNTIL}
                        variant={FORM_GROUP_VARIANTS.DATE}
                        inputProps={{
                            id: 'validUntil',
                            name: 'validUntil',
                            required: false,
                            value: stagedPremiumsWizard.validUntil,
                            dateInputProps: {
                                minDate: stagedPremiumsWizard.validFrom,
                                dateFormat: DATE_FORMAT,
                                onChange: evt => { changeStagedPremiumFormData('validUntil', evt) },
                                autoComplete: 'off',
                                selected: stagedPremiumsWizard.validUntil,
                                placeholderText: CONTENT_STRINGS.DATE_PLACEHOLDER,
                            },
                        }}
                        formGroupTestId={'staged-premium-setting-valid-to'}
                    />
                :
                    null
            }
        </div>
    );
};
export default StagedStep3;
